import React from "react";

import { useTitle } from "../../utils/UseTitleUtils";
import CommonIcons from "utils/CommonIcons";
import MarketingHero from "components/marketing/MarketingHero";

interface PurchaseCancelProps {}

const PurchaseCancel = (props: PurchaseCancelProps) => {
  useTitle("Purchase Cancelled!");
  return (
    <div className="marketing-page marketing-page--status">
      <main className="marketing-page__main">
        <MarketingHero title="Purchase Cancelled" />

        <section className="marketing-page__section">
          <div className="marketing-page__status-card">
            <div className="marketing-page__status-icon marketing-page__status-icon--error">
              <CommonIcons.CancelIcon />
            </div>
            <h1 className="marketing-page__status-title marketing-page__status-title--error">
              Purchase Cancelled!
            </h1>
            <div className="marketing-page__status-copy">
              <p>
                Purchase has been cancelled by you. Please complete the
                purchase again if this was accidental, or try again later if
                the problem persists.
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default PurchaseCancel;
